var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.buttonAvailable)?_c('button',{staticClass:"button is-primary is-small button-margin-top",attrs:{"type":"button","data-tooltip":_vm.buttonTooltip,"disabled":_vm.buttonDisabled},on:{"click":_vm.checkApp}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }